<template>
  <div class="no-datos" :class="`no-datos--${tamano}`">
    <i :class="`fa fa-${icon}`"></i>
    {{ labelLocal }}
  </div>
</template>

<script>

export default {
  props: {
    label: { type: String, default: null },
    icon: { type: String, default: 'chart-bar' },
    tamano: { type: String, default: 'md' },
  },
  computed: {
    labelLocal() {
      return this.label || this.$I18n.t('no_informacion_disponible');
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-datos {
    width: 100%;
    text-align: center;
    font-size: 1.2em;

    .fa {
      display: block;
      font-size: 62px;
      opacity: 0.5;
    }
    &--xl {
      font-size: 1.5em;

      .fa {
        font-size: 192px;
      }
    }
  }
</style>
